import React, { useState,useContext } from "react";
import {
  NavbarContainer,
  NavbarLink,
  MenuDrawer,
  MenuBarItem,
  DarkModeBtn,
} from "./navbar.styles";

import { ReactComponent as MyName } from "../../assets/svgs/my-name-new.svg";
import { Switch, Drawer } from "@mui/material";
import { Icon } from "@iconify/react";
import {ThemeContext} from '../../theme.context';

const MenuItem = ({ children, id, toggleMenu,dark }) => {
  const handleClick = () => {
    toggleMenu();
    document.getElementById(id).scrollIntoView({ behavior: "smooth" });
  };
  return <MenuBarItem onClick={handleClick} dark={dark} >{children}</MenuBarItem>;
};

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const {darkMode,toggleDarkMode} = useContext(ThemeContext);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <NavbarContainer dark={darkMode}>
      <MyName width="200px" className="logo-svg" />

      <div className="link-container">
        <NavbarLink href="#about-section" dark={darkMode}>HOME</NavbarLink>
        <NavbarLink href="#about-section" dark={darkMode}>ABOUT</NavbarLink>
        <NavbarLink href="#skills-section" dark={darkMode}>SKILLS</NavbarLink>
        <NavbarLink href="#timeline-section" dark={darkMode}>TIMELINE</NavbarLink>
        <NavbarLink href="#projects-section" dark={darkMode}>PROJECTS</NavbarLink>
        <NavbarLink href="#contact-section" dark={darkMode}>CONTACT ME</NavbarLink>
      </div>
      <div className="switch-section">
        <DarkModeBtn onClick={()=>{toggleDarkMode()}} dark={darkMode} >
          {!darkMode
           ? (
            <Icon icon="bxs:sun" fontSize="1.7em" color="#3957D2" />
          ) : (
            <Icon icon="bxs:moon" fontSize="1.7em" color="#FF3B81"  />
          )}
        </DarkModeBtn>
        <Icon
          icon="ant-design:menu-outlined"
          fontSize="2em"
          color={darkMode?"#1C2028":"#fff"}
          className="menu-svg"
          onClick={toggleMenu}
        />
      </div>
      <MenuDrawer anchor="right" open={isMenuOpen} onClose={toggleMenu} dark={darkMode} >
        <MyName width="200px" className="logo-svg" />
        <MenuItem id="about-section" toggleMenu={toggleMenu} dark={darkMode}>
          HOME
        </MenuItem>
        <MenuItem id="about-section" toggleMenu={toggleMenu} dark={darkMode}>
          ABOUT ME
        </MenuItem>
        <MenuItem id="skills-section" toggleMenu={toggleMenu} dark={darkMode}>
          SKILLS
        </MenuItem>
        <MenuItem id="timeline-section" toggleMenu={toggleMenu} dark={darkMode}>
          TIMELINE
        </MenuItem>
        <MenuItem id="projects-section" toggleMenu={toggleMenu} dark={darkMode}>
          PROJECTS
        </MenuItem>
        <MenuItem id="contact-section" toggleMenu={toggleMenu} dark={darkMode}>
          CONTACT ME
        </MenuItem>
      </MenuDrawer>
    </NavbarContainer>
  );
};

export default Navbar;
